import React from 'react';

import '@app/scss/components/mastheadNaked.scss';

interface MastheadNakedBaseProps {
	imageSrc: string;
	imageAlt?: string;
	title?: string;
}

const MastheadNaked: React.FC<MastheadNakedBaseProps> = (props) => {
	return (
		<div className="masthead-naked">
			<div className="masthead-naked-wrapper" style={{ backgroundImage: `url(${props.imageSrc})` }}>
				{props.title && <h1 className="masthead-naked__title">{props.title}</h1>}
				<img className="masthead-naked__edge" src={require('@app/images/triangle_edge-transparent.png')} />
			</div>
		</div>
	);
};

export default MastheadNaked;
